import React, { useState } from 'react';
import { Check, ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'completo' | 'basico'>('completo');
  const checkoutBasico = 'https://checkout.recursodigital.shop/cart/41319539540026:1';
  const checkoutCompleto = 'https://checkout.recursodigital.shop/cart/41319548846138:1';
  return <section id="oferta" className="bg-brand-dark py-5 px-5 scroll-mt-10" data-id="element-187">
      <div className="max-w-xl mx-auto" data-id="element-188">
        {/* Headline */}
        <div className="text-center mb-8" data-id="element-189">
          <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-2" data-id="element-190">
            Elegí tu{' '}
            <span className="text-brand-yellow" data-id="element-191">
              MegaPack de Inicial sin Estrés:
            </span>
          </h2>
          <p className="text-sm text-gray-400" data-id="element-192">
            Las dos opciones incluyen los 6 bonos estratégicos
          </p>
        </div>

        {/* Option 1 - Basic */}
        <button onClick={() => setSelected('basico')} className={`w-full text-left bg-gray-900 rounded-xl p-5 mb-4 border-2 transition-all ${selected === 'basico' ? 'border-gray-500' : 'border-gray-800'}`} data-id="element-193">
          <div className="flex items-start justify-between gap-4" data-id="element-194">
            <div className="flex items-start gap-3" data-id="element-195">
              {/* Radio */}
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 mt-0.5 flex items-center justify-center ${selected === 'basico' ? 'border-white' : 'border-gray-600'}`} data-id="element-196">
                {selected === 'basico' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-197" />}
              </div>
              <div data-id="element-198">
                <div className="flex items-center gap-2 mb-1" data-id="element-199">
                  <span className="text-base" data-id="element-200">📘</span>
                  <h4 className="text-sm font-black text-white uppercase" data-id="element-201">
                    MEGAPACK INICIAL
                  </h4>
                </div>
                <p className="text-xs text-gray-500" data-id="element-202">6 tomos + 6 bonos</p>
              </div>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-203">
              <div className="text-xs text-gray-600 line-through" data-id="element-204">S/.49.90</div>
              <div className="text-2xl font-black text-white" data-id="element-205">S/.29.90</div>
            </div>
          </div>
        </button>

        {/* Option 2 - Highlighted */}
        <button onClick={() => setSelected('completo')} className={`w-full text-left bg-gray-900 rounded-xl p-5 relative border-2 transition-all ${selected === 'completo' ? 'border-brand-yellow' : 'border-gray-800'}`} data-id="element-206">
          <div className="flex items-start justify-between gap-4" data-id="element-207">
            <div className="flex items-start gap-3" data-id="element-208">
              {/* Radio */}
              <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 mt-0.5 flex items-center justify-center ${selected === 'completo' ? 'border-brand-yellow' : 'border-gray-600'}`} data-id="element-209">
                {selected === 'completo' && <div className="w-2.5 h-2.5 rounded-full bg-brand-yellow" data-id="element-210" />}
              </div>
              <div data-id="element-211">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-212">
                  <span className="text-base" data-id="element-213">🏆</span>
                  <h4 className="text-sm font-black text-white uppercase" data-id="element-214">
                    MEGAPACK + SISTEMA AULA LISTA™
                  </h4>
                </div>
                <div className="flex flex-wrap gap-2 mb-2" data-id="element-215">
                  <span className="bg-brand-yellow text-black text-[10px] font-black px-2 py-0.5 rounded-md" data-id="element-216">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="bg-green-600 text-white text-[10px] font-black px-2 py-0.5 rounded-md" data-id="element-217">
                    AHORRÁS S/.30
                  </span>
                </div>
                <p className="text-xs text-gray-400" data-id="element-218">
                  6 tomos + 6 bonos + Sistema Aula Lista™
                </p>
                <p className="text-[11px] text-gray-600 mt-1" data-id="element-219">
                  (Sistema visual de control, rutinas y planificación del aula)
                </p>
              </div>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-220">
              <div className="text-xs text-gray-600 line-through" data-id="element-221">S/.99.90</div>
              <div className="text-2xl font-black text-white" data-id="element-222">S/.69.90</div>
            </div>
          </div>
        </button>

        {/* CTA Button */}
        <a href={selected === 'completo' ? checkoutCompleto : checkoutBasico} className="block w-full bg-brand-yellow hover:bg-brand-yellowHover text-black md:text-lg py-4 px-6 rounded-xl shadow-[0_4px_20px_0_rgba(251,191,36,0.4)] transition-all hover:scale-[1.02] text-center mt-8 mb-4 text-[14px] font-[900]" data-id="element-223">
          {selected === 'completo' ? 'SÍ, QUIERO EL MEGAPACK + AULA LISTA →' : 'QUIERO MI MEGAPACK AHORA →'}
        </a>

        {/* Subtitle */}
        <p className="text-center text-xs text-gray-500 italic mb-6 max-w-sm mx-auto leading-relaxed" data-id="element-224">
          {selected === 'completo' ? 'La opción más elegida por maestras que quieren control total del aula y clases organizadas' : 'Incluye los 6 tomos completos y los 6 bonos estratégicos'}
        </p>

        {/* Trust badges */}
        <div className="bg-gray-900 border border-gray-800 rounded-xl py-3 px-4" data-id="element-225">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-gray-400" data-id="element-226">
            <div className="flex items-center gap-1.5" data-id="element-227">
              <Lock size={13} className="text-brand-yellow" data-id="element-228" />
              Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-229">
              <Zap size={13} className="text-brand-yellow" data-id="element-230" />
              Acceso en 5 min
            </div>
            <div className="flex items-center gap-1.5" data-id="element-231">
              <ShieldCheck size={13} className="text-brand-yellow" data-id="element-232" />
              Garantía 7 días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-233">
              <CreditCard size={13} className="text-brand-yellow" data-id="element-234" />
              Pago local
            </div>
          </div>
        </div>
      </div>
    </section>;
}